import React from 'react';
import domainModel from 'domain-model';
import { weekdays } from './common';

type DeliveryRulesEditorType =
  typeof domainModel.deliveryRules.DeliveryRulesEditor;

const { getWeekdayName } = domainModel.deliveryRules;

interface SimplifiedRulesViewerProps {
  region: string;
  deliveryRulesEditor?: DeliveryRulesEditorType;
}
const SimplifiedRulesViewer: React.FC<SimplifiedRulesViewerProps> = props => {
  const { deliveryRulesEditor, region } = props;

  const ruleTexts = weekdays
    .map(weekday => {
      const deliveryRule = deliveryRulesEditor.getRuleWithRegionAndKey(
        region,
        weekday.key,
      );
      if (!deliveryRule) return '';
      return `${getWeekdayName(weekday.key)}`;
    })
    .filter(deliveryRule => !!deliveryRule)
    .join(', ');

  return <div>Valda leveransdagar: &nbsp;{ruleTexts}</div>;
};

export default SimplifiedRulesViewer;
